import React, { useState } from 'react';
import clsx from 'clsx';
import { useTranslation } from 'next-i18next';
import Button from '../atoms/Button';
import Property from '../atoms/Property';
import styles from '../../styles/components/molecules/VenueSpaceListed.module.scss';

interface VenueSpaceListedProps {
  className?: string;
  onClick?: () => void;
  float?: boolean;
  data: {
    id: string;
    cat: string;
    name: string;
    description?: string;
    specs: {
      id: string;
      label: string;
      value: string | number;
      unit: string;
      expand?: boolean;
    }[];
  };
  forwardedRef?: any;
  access?: boolean;
}

export default function VenueSpaceListed(props: VenueSpaceListedProps) {
  const { t } = useTranslation(['common']);
  const [hover, setHover] = useState(false);
  const { data, float, onClick, className, forwardedRef, access } = props;
  const { name, description, specs } = data as any;
  const classes = clsx(
    styles.venueSpaceListed,
    { [styles.float]: !!float },
    { [styles.hover]: hover },
    { [styles.more]: !!onClick },
    { [styles.access]: !!access },
    className || null
  );

  return (
    <div
      className={classes}
      onMouseOver={() => setHover(true)}
      onMouseOut={() => setHover(false)}
      onClick={!access ? onClick : undefined}
      ref={forwardedRef}
    >
      <div>
        <p>
          <b>{name}</b>
          <br />
          {!!description && <small>{description}</small>}
        </p>
        <ul>
          {specs
            .filter((el: any) => !el.expand)
            .map((el: any, index: number) => (
              <li key={index}>
                <Property
                  icon={el.id}
                  label={''}
                  value={el.value}
                  unit={el.unit}
                  iconSplit={el.id === 'capacity_per_type' ? '/' : ''}
                />
              </li>
            ))}
        </ul>
      </div>
      {!!onClick && <Button small icon="expand" onClick={onClick} />}
      {!!onClick && (
        <Button
          small
          more
          colored
          label={t(`common:cta-more`)}
          hover={hover}
          onClick={onClick}
        />
      )}
    </div>
  );
}
